import ReaderDetail from './components/ReaderDetail'
import ReaderEvents from './components/ReaderEvents'
import ReaderList from './components/ReaderList'
import { Routes, Route, Navigate } from 'react-router-dom'
import ReaderReport from './components/ReaderReport'
import { Login } from 'components/Login'
import ProtectedRoute from 'utils/ProtectedRoute'

function App() {
  return (
    <Routes>
      <Route path='login' element={<Login />} />
      <Route
        path='readers'
        element={
          <ProtectedRoute>
            <ReaderList />
          </ProtectedRoute>
        }
      />
      <Route
        path='readers/:id'
        element={
          <ProtectedRoute>
            <ReaderDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path='readers/:id/events/:date'
        element={
          <ProtectedRoute>
            <ReaderEvents />
          </ProtectedRoute>
        }
      />
      <Route
        path='readers/:id/report/:type/:date'
        element={
          <ProtectedRoute>
            <ReaderReport />
          </ProtectedRoute>
        }
      />
      <Route path='*' element={<Navigate replace to='/readers' />} />
    </Routes>
  )
}

export default App
